var _=10,E=10,I=10485760;export{E as MAX_DOWNLOAD_FILE_SIZE,_ as MAX_FILES,I as MAX_FILE_SIZE};
//# sourceMappingURL=constants.js.map